import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const DhanlaxmiCarloanEMiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is an EMI?",
            "answer": "An EMI is a fixed monthly payment to repay both the principal and interest on your loan."
          },
          {
            "question": "Why should I use TheFinMaster’s EMI calculator?",
            "answer": "It offers instant, accurate, and free calculations tailored for Dhanlaxmi Bank."
          },
          {
            "question": "Is the calculator specific to Dhanlaxmi Bank loans?",
            "answer": "Yes, it uses parameters relevant to Dhanlaxmi Bank car loans."
          },
          {
            "question": "Can I adjust interest rates and tenure?",
            "answer": "Yes, you can customize these fields to reflect your desired loan structure."
          },
          {
            "question": "Is it free to use?",
            "answer": "Absolutely. It is free and does not require registration."
          },
          {
            "question": "Does it show total interest payable?",
            "answer": "Yes, along with EMI, you’ll see total interest and total payment."
          },
          {
            "question": "Can I use it on mobile devices?",
            "answer": "Yes, it's mobile-optimized for easy access on smartphones and tablets."
          },
          {
            "question": "Will my credit score affect the result?",
            "answer": "No, the calculator does not pull or impact your credit score."
          },
          {
            "question": "Is the EMI fixed for the entire tenure?",
            "answer": "Yes, unless you opt for a floating interest rate loan."
          },
          {
            "question": "Can I save or print the amortisation schedule?",
            "answer": "Yes, you can download or print the schedule for future reference."
          },
          {
            "question": "What if I prepay the loan?",
            "answer": "Prepayment reduces the principal, lowering interest and EMI burden."
          },
          {
            "question": "Does the calculator include processing fees?",
            "answer": "No, it focuses on principal, interest, and tenure. You should consider processing fees separately."
          },
          {
            "question": "How accurate is this calculator?",
            "answer": "It is highly accurate based on the details you provide."
          },
          {
            "question": "Can I use it for used car loans?",
            "answer": "Yes, just input the relevant loan parameters."
          },
          {
            "question": "Where can I apply for a Dhanlaxmi Bank car loan?",
            "answer": "You can apply via the official Dhanlaxmi Bank website or visit the nearest branch. Always use our EMI calculator beforehand for smart planning."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
          <title>Dhanlaxmi Bank Car Loan EMI Calculator – Quick EMI Computation</title>
        <meta  name='description' content='Calculate EMIs for your Dhanlaxmi Bank car loan. Forecast payments and manage your car financing with clarity.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/dhanlaxmi-bank-car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Dhanlaxmi  Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
       <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
            <h1 className="text-2xl font-bold mb-4">Dhanlaxmi Car Loan EMI Calculator</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Dhanlaxmi Bank Car Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Owning a car is no longer a distant dream, thanks to car loans offered by banks like Dhanlaxmi Bank, which make vehicle financing simpler and more affordable. But before committing to a loan, it’s essential to understand how much you’ll be repaying monthly. That’s where TheFinMaster’s Dhanlaxmi Bank Car Loan EMI Calculator steps in—your go-to tool for transparent, accurate, and instant EMI planning. With just a few inputs like loan amount, interest rate, and tenure, you can visualize your monthly commitments and plan your finances better. Whether you're eyeing a compact hatchback or a luxurious sedan, this calculator empowers you to make informed decisions tailored to your financial comfort zone. Avoid guesswork, avoid surprises—let TheFinMaster simplify your car loan journey with precision and ease.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Car Loan EMI (Equated Monthly Instalment) is a fixed monthly payment made by a borrower to repay a car loan over a predetermined period. This amount includes both the principal and the interest component, spread evenly over the loan tenure. Understanding EMIs is crucial for budget planning, as it helps you gauge your monthly financial commitment toward the car loan. The EMI depends on several factors such as loan amount, interest rate, and tenure. Knowing the exact EMI allows you to make informed decisions about your car purchase and choose a loan structure that aligns with your financial capabilities.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMIs are calculated using a standard formula that considers the principal amount, the rate of interest, and the duration of the loan. The longer the tenure, the lower the EMI, but the higher the total interest outgo. Conversely, shorter tenures lead to higher EMIs but lesser interest paid. With a clear understanding of EMIs, you can plan your repayments efficiently without straining your monthly finances.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Dhanlaxmi Bank Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Dhanlaxmi Bank Car Loan EMI Calculator is a smart, user-friendly tool developed by TheFinMaster to help users calculate the exact EMI for their Dhanlaxmi Bank car loans. This digital calculator enables prospective car buyers to simulate their loan repayment scenario in just a few clicks. By entering details such as loan amount, interest rate, and tenure, users can instantly view their monthly EMI amount.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator is especially helpful for those who are considering taking a car loan from Dhanlaxmi Bank. It saves you from manual calculations and provides a breakdown of your monthly obligations, ensuring full financial clarity. Moreover, it allows you to try multiple combinations to find the most affordable EMI that suits your budget. It's a vital tool for responsible financial planning.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Dhanlaxmi Bank Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s EMI Calculator for Dhanlaxmi Bank offers a host of advantages:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Quick and Accurate Results:</strong> Get precise EMI calculations within seconds, eliminating the need for complex manual computations.</li>
              <li><strong>Free of Cost:</strong> The calculator is available for free on TheFinMaster platform, ensuring accessibility to all users.</li>
              <li><strong>User-Friendly Interface:</strong> Even those with minimal technical knowledge can operate the calculator effortlessly.</li>
              <li><strong>Customizable Inputs:</strong> Adjust loan amount, interest rate, and tenure to see how your EMI changes.</li>
              <li><strong>Real-Time Planning:</strong> Get real-time figures to make well-informed decisions regarding your loan.</li>
              <li><strong>Comparison Support:</strong> Compare multiple loan scenarios to find the best deal that matches your financial goals.</li>
              <li><strong>Risk Mitigation:</strong> Understand your financial commitments before opting for the loan, minimizing chances of default.</li>
              <li><strong>No Personal Information Required:</strong> Use the tool anonymously without entering personal data.</li>
              <li><strong>Accessible Anytime, Anywhere:</strong> Available online, so you can use it at your convenience.</li>
              <li><strong>Tailored for Dhanlaxmi Bank Loans:</strong> The calculator is specifically designed to reflect the terms and conditions typical of Dhanlaxmi Bank’s car loans.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Dhanlaxmi Bank Car Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Dhanlaxmi Bank Car Loan EMI Calculator operates based on a universally accepted formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P × R × (1+R)^N] / [(1+R)^N–1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal Loan Amount</li>
              <li>R = Monthly Interest Rate (Annual Rate divided by 12 and by 100)</li>
              <li>N = Loan Tenure in Months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Suppose you want to take a car loan of ₹10,00,000 at an interest rate of 9% per annum for a tenure of 5 years (60 months).<br />
              P = ₹10,00,000<br />
              R = 9 / 12 / 100 = 0.0075<br />
              N = 60<br />
              Plugging into the formula: EMI = [10,00,000 × 0.0075 × (1+0.0075)^60] / [(1+0.0075)^60 – 1] ≈ ₹20,758<br />
              This means your monthly EMI would be approximately ₹20,758. The total amount paid over 5 years would be around ₹12,45,480, including ₹2,45,480 as interest.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a table that details each EMI payment over the tenure of your loan. It breaks down each payment into the interest and principal components, helping you understand how your loan progresses. In the early months, a higher portion of your EMI goes toward interest, and gradually, the principal component increases. This schedule offers a complete view of how your loan is repaid over time.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Sample for ₹6,00,000 at 9% p.a. for 5 years):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,500</td>
                    <td className="border px-4 py-2">7,955</td>
                    <td className="border px-4 py-2">5,92,045</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,440</td>
                    <td className="border px-4 py-2">8,015</td>
                    <td className="border px-4 py-2">5,84,030</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,380</td>
                    <td className="border px-4 py-2">8,075</td>
                    <td className="border px-4 py-2">5,75,955</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,320</td>
                    <td className="border px-4 py-2">8,135</td>
                    <td className="border px-4 py-2">5,67,820</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,260</td>
                    <td className="border px-4 py-2">8,195</td>
                    <td className="border px-4 py-2">5,59,625</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,197</td>
                    <td className="border px-4 py-2">8,258</td>
                    <td className="border px-4 py-2">5,51,367</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,135</td>
                    <td className="border px-4 py-2">8,320</td>
                    <td className="border px-4 py-2">5,43,047</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,073</td>
                    <td className="border px-4 py-2">8,382</td>
                    <td className="border px-4 py-2">5,34,665</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">4,010</td>
                    <td className="border px-4 py-2">8,445</td>
                    <td className="border px-4 py-2">5,26,220</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">3,947</td>
                    <td className="border px-4 py-2">8,508</td>
                    <td className="border px-4 py-2">5,17,712</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">3,884</td>
                    <td className="border px-4 py-2">8,571</td>
                    <td className="border px-4 py-2">5,09,141</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">12,455</td>
                    <td className="border px-4 py-2">3,821</td>
                    <td className="border px-4 py-2">8,634</td>
                    <td className="border px-4 py-2">5,00,507</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Interest  (₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left"> Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹12,455", "₹4,500", "₹7,955", "₹5,92,045"],
          ["2", "₹12,455", "₹4,440", "₹8,015", "₹5,84,030"],
          ["3", "₹12,455", "₹4,380", "₹8,075", "₹5,75,955"],
          ["4", "₹12,455", "₹4,320", "₹8,135", "₹5,67,820"],
          ["5", "₹12,455", "₹4,260", "₹8,195", "₹5,59,625"],
          ["6", "₹12,455", "₹4,197", "₹8,258", "₹5,51,367"],
          ["7", "₹12,455", "₹4,135", "₹8,320", "₹5,43,047"],
          ["8", "₹12,455", "₹4,073", "₹8,382", "₹5,34,665"],
          ["9", "₹12,455", "₹4,010", "₹8,445", "₹5,26,220"],
          ["10", "₹12,455", "₹3,947", "₹8,508", "₹5,17,712"],
          ["11", "₹12,455", "₹3,884", "₹8,571", "₹5,09,141"],
          ["12", "₹12,455", "₹3,821", "₹8,634", "₹5,00,507"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
            ["1", "₹12,455", "₹4,500", "₹7,955", "₹5,92,045"],
            ["2", "₹12,455", "₹4,440", "₹8,015", "₹5,84,030"],
            ["3", "₹12,455", "₹4,380", "₹8,075", "₹5,75,955"],
            ["4", "₹12,455", "₹4,320", "₹8,135", "₹5,67,820"],
            ["5", "₹12,455", "₹4,260", "₹8,195", "₹5,59,625"],
            ["6", "₹12,455", "₹4,197", "₹8,258", "₹5,51,367"],
            ["7", "₹12,455", "₹4,135", "₹8,320", "₹5,43,047"],
            ["8", "₹12,455", "₹4,073", "₹8,382", "₹5,34,665"],
            ["9", "₹12,455", "₹4,010", "₹8,445", "₹5,26,220"],
            ["10", "₹12,455", "₹3,947", "₹8,508", "₹5,17,712"],
            ["11", "₹12,455", "₹3,884", "₹8,571", "₹5,09,141"],
            ["12", "₹12,455", "₹3,821", "₹8,634", "₹5,00,507"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> Higher loan amounts directly increase your EMI. It’s essential to borrow only what you need to keep your EMI affordable.</li>
                <li><strong>Interest Rate:</strong> The rate set by Dhanlaxmi Bank greatly influences your EMI. Lower rates translate to more affordable repayments.</li>
                <li><strong>Loan Tenure:</strong> A longer tenure reduces the EMI but increases the total interest paid over time.</li>
                <li><strong>Down Payment:</strong> A larger upfront payment reduces the principal amount, thereby decreasing EMI.</li>
                <li><strong>Credit Score:</strong> A good credit score may fetch you a lower interest rate, reducing EMI.</li>
                <li><strong>Income Stability:</strong> Higher and stable income may allow for shorter tenures and higher EMIs for quicker repayment.</li>
                <li><strong>Prepayment Options:</strong> Loans with flexible prepayment terms can help reduce the principal quicker, lowering future EMIs.</li>
                <li><strong>Processing Fees and Charges:</strong> These additional costs indirectly affect your affordability and should be factored into planning.</li>
                <li><strong>Type of Car:</strong> New cars often attract lower interest rates compared to used cars.</li>
                <li><strong>Relationship with Bank:</strong> Existing customers might get preferential interest rates, thereby lowering EMIs.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                        {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default DhanlaxmiCarloanEMiCalculator ;
